import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent implements OnInit {
  @ViewChild('fab') fab: ElementRef;
  @Input('loadServ') public loadServ: boolean = true;
  @Input('data') public data: any;
  public moreInfoData: any = null;
  public dataInfo: any = null;
  public abierto: any = false;

  constructor(
    private _homeService: HomeService,
    private router: Router
  ) {

  }

  ngOnInit() {
    // console.log('More Info input: ', this.data);
    // if (!this.loadServ) {
      this.getGeneralOptions();
    // } else {
    //   this.loadData(this.data);
    // }
  }

  /**
   * @description Una vez renderizado, se ejecutan las funciones para detectar el scroll y ajustar el sticky de 'más información'
   */
  ngAfterContentInit(): void {
  }


  showInfo() {
    window.onscroll = function() {
      onScrollInfo();
    };

    // Get the header
    var fab = this.fab.nativeElement; // document.getElementById('fab');

    // Get the offset position of the navbar
    var sticky = fab.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove 'sticky' when you leave the scroll position
    function onScrollInfo() {
      
      sticky = getComputedStyle(fab).display=='none'?700:sticky;
      if (window.pageYOffset > sticky) {
        fab.classList.add('zoom-fixed');
        fab.classList.remove('zoom');
      } else {
        fab.classList.remove('zoom-fixed');
        fab.classList.add('zoom');
      }
    }
  }

  /**
   * @description Despliega los iconos de 'más información' (Whatsapp, Teléfono, GPS)
   */
  openInfo() {
    const display = $('.zoom-menu').css('display');

    if (display === 'none') {
      $('.zoom-menu').css('display', 'block');
    } else {
      $('.zoom-menu').css('display', 'none');
    }

    $('.zoom-btn-sm').toggleClass('scale-out');
    if (!$('.zoom-card').hasClass('scale-out')) {
      $('.zoom-card').toggleClass('scale-out');
    }
  }

  /**
   * @description Scale-out al darle click en los iconos de 'más información'
   */
  navigateInfo(option) {
    if ($('.zoom-card').hasClass('scale-out')) {
      $('.zoom-card').toggleClass('scale-out');
    }
    switch (option) {
      case 'phone':
        if (this.dataInfo.showhorary) {
          $('#modalTelephone').modal('show');
        } else {
          window.location.assign('tel:' + this.dataInfo.telefono);
        }
        break;
      case 'sucursal':
        this.router.navigate(['sucursales']);
        break;
      case 'whatsapp':
        if (this.dataInfo.showhorary) {
          $('#modalWhatsapp').modal('show');
        } else {
          window.location.assign('tel:' + this.dataInfo.whatsapp);
        }
        break;
    }
  }

  getGeneralOptions() {
    this._homeService.getGeneralOptions().subscribe(
      data => {
        console.log('Datos de barra mas información:', data.data);
        this.loadData(data.data);
      },
      err => {
        console.error(err);
      }
    );
  }
  loadData(data) {
    this.moreInfoData = data.modals;
    this.dataInfo = data;
    if (
      !(
        data &&
        data.modals &&
        JSON.stringify(data.modals).length > 3
      )
    ) {
      console.warn('Sin data general');
    } else {
      this.showInfo();
    }
  }
}
